import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateMerchantOrderSharedLinkMutationVariables = Types.Exact<{
  input: Types.CreateMerchantOrderSharedLinkInput;
}>;


export type CreateMerchantOrderSharedLinkMutation = { __typename?: 'Mutation', createMerchantOrderSharedLink: { __typename?: 'MerchantOrderSharedLink', id: string } };


export const CreateMerchantOrderSharedLinkDocument = gql`
    mutation CreateMerchantOrderSharedLink($input: CreateMerchantOrderSharedLinkInput!) {
  createMerchantOrderSharedLink(input: $input) {
    id
  }
}
    `;
export type CreateMerchantOrderSharedLinkMutationFn = Apollo.MutationFunction<CreateMerchantOrderSharedLinkMutation, CreateMerchantOrderSharedLinkMutationVariables>;

/**
 * __useCreateMerchantOrderSharedLinkMutation__
 *
 * To run a mutation, you first call `useCreateMerchantOrderSharedLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMerchantOrderSharedLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMerchantOrderSharedLinkMutation, { data, loading, error }] = useCreateMerchantOrderSharedLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMerchantOrderSharedLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateMerchantOrderSharedLinkMutation, CreateMerchantOrderSharedLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMerchantOrderSharedLinkMutation, CreateMerchantOrderSharedLinkMutationVariables>(CreateMerchantOrderSharedLinkDocument, options);
      }
export type CreateMerchantOrderSharedLinkMutationHookResult = ReturnType<typeof useCreateMerchantOrderSharedLinkMutation>;
export type CreateMerchantOrderSharedLinkMutationResult = Apollo.MutationResult<CreateMerchantOrderSharedLinkMutation>;
export type CreateMerchantOrderSharedLinkMutationOptions = Apollo.BaseMutationOptions<CreateMerchantOrderSharedLinkMutation, CreateMerchantOrderSharedLinkMutationVariables>;